import { render, staticRenderFns } from "./SuggestFilters.vue?vue&type=template&id=44bf352d"
import script from "./SuggestFilters.vue?vue&type=script&lang=js"
export * from "./SuggestFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports